import React, { useEffect } from 'react'

import { Table, Typography, Form } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons';
import LotNumber from './LotNumber';
import Incrementor from './Incrementor';

const { Text } = Typography

export default function ProductKits({ kits, isComplete, registerForm,
    addSkuLot, removeSkuLot, productId, isLoading
}) {

    const [form] = Form.useForm();

    useEffect(() => {
        registerForm(form);
    }, [form, registerForm]);


    const columns = [
        {
            title: "SKU",
            key: "inventoryProductId",
            width: 160,
            render: (kit, _, index) => {
                return (
                    <div style={{ gap: 8, display: "flex", alignItems: "center" }}>
                        <Text style={{ fontSize: 16 }}>
                            {kit.inventoryProductId}
                        </Text>
                        {isComplete && (
                            <CheckCircleOutlined style={{ fontSize: 20, color: "#52c41a" }}
                            />
                        )}
                        <Form.Item hidden name={['transactions', kit.key, 'inventoryProductId']} initialValue={kit.inventoryProductId}>
                            <input />
                        </Form.Item>
                        <Form.Item hidden name={['transactions', kit.key, 'comment']} initialValue={productId}>
                            <input />
                        </Form.Item>
                    </div>
                );
            },
        },
        {
            title: "Description",
            key: "productName",
            dataIndex: "productName",
        },
        {
            title: "Lot",
            key: "lot",
            width: 250,
            render: (kit, _, index) => {
                return (
                    <LotNumber
                        // form={form}
                        disabled={isComplete}
                        index={index}
                        // required={kit?.quantity > 0}
                        // lot={lot?.lot}
                        lots={kit?.lots}
                        keyProp={kit?.key}
                        isDynamic={kit?.isDynamic}
                        facilityProductId={kit?.facilityProductId}
                        onChangeLot={(lot) => {
                            onChangeLot(kit.key, lot)
                        }}
                        addSkuLot={addSkuLot}
                        removeSkuLot={removeSkuLot}
                    // onChangeLot={(inventoryId, lot) =>
                    //     onChangeLot(index, inventoryId, lot)
                    // }
                    />
                );
            },
        },
        {
            title: "Qty",
            width: 200,

            render: (kit, _, index) => {
                return (
                    <Incrementor
                        disabled={isComplete}
                        maxQuantity={kit?.maxQuantity}
                        quantity={kit?.quantity}
                        index={index}
                        initialValue={kit.quantity}
                        keyProp={kit?.key}
                        onIncrement={() => onChangeQuantity(kit.key, +1)}
                        onDecrement={() => onChangeQuantity(kit.key, -1)}
                    />
                );
            },
        },
    ];

    const onChangeLot = (key, lot) => {
        console.log('key', key)
        form.setFields([
            {
                name: ['transactions', key, 'lotNumber'],
                value: lot?.lotNumber
            },
            {
                name: ['transactions', key, 'facilityProductId'],
                value: lot?.facilityProductId
            },
            {
                name: ['transactions', key, 'inventoryId'],
                value: lot?.inventoryId
            },
        ])
    }

    const onChangeQuantity = (key, delta) => {
        const formValues = form.getFieldsValue()
        const currentQuantity = formValues?.transactions?.[key]?.quantity || 0;
        if (currentQuantity + delta < 0) return;
        form.setFields([{
            name: ['transactions', key, 'quantity'],
            value: currentQuantity + delta
        }])
    };



    return (
        <Form
            preserve={false}
            form={form}
            name={`prefcard-${productId}`}
        >
            <Table
                rowKey={'key'}
                tableLayout="auto"
                dataSource={kits ?? []}
                columns={columns}
                pagination={false}
                scroll={{ x: true }}
                style={{ marginBottom: 16 }}
                loading={isLoading}
                locale={{
                    emptyText: "No Items",
                }}
            />
        </Form>

    )
}
